import React, { useState } from 'react';
import { View, ScrollView } from 'react-native';

import { TextInputMask } from 'react-native-masked-text';
import { useSelector } from 'react-redux';
import { AppHeader } from '../../../components/common';
import { AppText, AppSelector } from '../../../components/form';
import { GreenButton } from '../../../components/derivative';
import styles from './styles';
import { API } from '../../../service/api';

const LevelFour = ({ navigation }) => {
  const { pnfamData, workerData } = useSelector((state) => state.worker);
  const [levelFourParams, updateL4Params] = useState({
    quality: '',
    healthy: '',
    lunch: '',
    fried: '',
    fruit: '',
    isInPlan: undefined,
    wishToPlan: undefined,
  });
  const optionsYesNo = [
    { label: 'SIM', value: 1 },
    { label: 'NÃO', value: 0 },
  ];
  const optionsYesNoMaybe = [
    ...optionsYesNo,
    { label: 'TALVEZ', value: 2 },
  ];
  const nextPage = () => {
    setDataAPI();
  };
  const setDataAPI = async () => {
    await API.post('/create/pnfam', {
      id_colaborador: workerData.id_colaborador,
      cervical: pnfamData.cervical,
      centro_costas: pnfamData.centro_costas,
      lombar: pnfamData.lombar,
      peitoral: pnfamData.peitoral,
      ombro_esquerdo: pnfamData.ombro_esquerdo,
      ombro_direito: pnfamData.ombro_direito,
      perna_esquerda: pnfamData.perna_esquerda,
      perna_direita: pnfamData.perna_direita,
      punho_esquerdo: pnfamData.punho_esquerdo,
      punho_direito: pnfamData.punho_direito,
      pe_esquerdo: pnfamData.pe_esquerdo,
      pe_direito: pnfamData.pe_direito,
      desconforto_fisico: pnfamData.desconforto_fisico,
      dor_constante: pnfamData.dor_constante,
      nota_postura: pnfamData.posture,
      cansaco_fisico: pnfamData.tiredness,
      estresse: pnfamData.estresse,
      ansiedade: pnfamData.ansiedade,
      qualidade_sono: pnfamData.qualidade_sono,
      dor_cabeca: pnfamData.dor_cabeca,
      qualidade_alimentacao: levelFourParams.quality,
      alimentos_saudaveis: levelFourParams.healthy,
      lanches: levelFourParams.lunch,
      frituras_gorduras: levelFourParams.fried,
      frutas: levelFourParams.fruit,
      plano_alimentacao: levelFourParams.isInPlan,
      melhorar_alimentacao: levelFourParams.wishToPlan,
      data_preenchimento: new Date(),
    });

    navigation.navigate('Worker Level Complete');
  };
  return (
    <View style={styles.viewBase}>
      <AppHeader title="Alimentação" hasBack navigation={navigation} />
      <View style={styles.content}>
        <ScrollView style={styles.scroll}>
          <View style={styles.viewL2Params}>
            <AppText size="bold" style={styles.textClassify}>{'CLASSIFIQUE A QUALIDADE\nDA SUA ALIMENTAÇÃO'}</AppText>
            <AppText style={styles.textClassify}>QUALIDADE DA ALIMENTAÇÃO SEMANAL</AppText>
            <TextInputMask value={levelFourParams.quality} type="only-numbers" maxLength={2} onChangeText={(quality) => updateL4Params({ ...levelFourParams, quality })} placeholder="1 - FRACA / 10 - ALTA" keyboardType="numeric" style={[styles.input, styles.inputNoIcon]} />
            <AppText style={styles.textClassify}>INGESTÃO DE ALIMENTOS SAUDÁVEIS</AppText>
            <TextInputMask value={levelFourParams.healthy} type="only-numbers" maxLength={2} onChangeText={(healthy) => updateL4Params({ ...levelFourParams, healthy })} placeholder="1 - FRACA / 10 - ALTA" keyboardType="numeric" style={[styles.input, styles.inputNoIcon]} />
            <AppText style={styles.textClassify}>INGESTÃO DE LANCHES</AppText>
            <TextInputMask value={levelFourParams.lunch} type="only-numbers" maxLength={2} onChangeText={(lunch) => updateL4Params({ ...levelFourParams, lunch })} placeholder="1 - FRACA / 10 - ALTA" keyboardType="numeric" style={[styles.input, styles.inputNoIcon]} />
            <AppText style={styles.textClassify}>INGESTÃO DE FRITURAS E GORDURAS</AppText>
            <TextInputMask value={levelFourParams.fried} type="only-numbers" maxLength={2} onChangeText={(fried) => updateL4Params({ ...levelFourParams, fried })} placeholder="1 - FRACA / 10 - ALTA" keyboardType="numeric" style={[styles.input, styles.inputNoIcon]} />
            <AppText style={styles.textClassify}>INGESTÃO DE FRUTAS</AppText>
            <TextInputMask value={levelFourParams.fruit} type="only-numbers" maxLength={2} onChangeText={(fruit) => updateL4Params({ ...levelFourParams, fruit })} placeholder="1 - FRACA / 10 - ALTA" keyboardType="numeric" style={[styles.input, styles.inputNoIcon]} />

            <View>
              <AppText style={styles.textClassify}>{'ESTÁ SEGUINDO ALGUM PLANO\nDE ALIMENTAÇÃO SAUDÁVEL?'}</AppText>
              <AppSelector
                options={optionsYesNo}
                optionValue="value"
                optionText="label"
                target="isInPlan"
                changeData={(target, value) => updateL4Params({ ...levelFourParams, [target]: value })}
                fieldValue={levelFourParams.isInPlan}
              />
            </View>
            <View>
              <AppText style={styles.textClassify}>{'DESEJA MELHORAR SUA\nALIMENTAÇÃO DIÁRIA'}</AppText>
              <AppSelector
                options={optionsYesNoMaybe}
                optionValue="value"
                optionText="label"
                target="wishToPlan"
                changeData={(target, value) => updateL4Params({ ...levelFourParams, [target]: value })}
                fieldValue={levelFourParams.wishToPlan}
              />
            </View>
            <GreenButton
              onPress={() => nextPage()}
              label="ENVIAR DADOS"
            />
          </View>
        </ScrollView>
      </View>
    </View>
  );
};

export default LevelFour;
